<template>
  <el-dialog title="Seleccionar bodega" :visible.sync="showDialogSelectBranch" width="50%" :center="true"
    :before-close="handleClose">
    <el-row :gutter="20" v-loading="loading">
      <el-col :span="12">
        <p>Bodega de origen</p>
        <branch-select-component :default="defaultBranch" @clear="clear(1)" @select="selectBranch(1, ...arguments)"
          @stop-loading="stopLoading(...arguments)" :disabled="true" />
        <!-- <branch-autocomplete-component 
          :default="defaultBranch"
          @clear="clear(1)" 
          @select="selectBranch(1, ...arguments)"
        /> -->
      </el-col>
      <el-col :span="12">
        <p>Bodega de destino</p>
        <branch-select-component :default="defaultBranchDestination" @clear="clear(2)"
          @select="selectBranch(2, ...arguments)" @stop-loading="stopLoading(...arguments)" :disabled="false" />
        <!-- <branch-autocomplete-component :default="defaultBranchDestination" @clear="clear(2)"
          @select="selectBranch(2, ...arguments)" /> -->
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">Cancelar</el-button>
      <el-button type="primary" icon="el-icon-check" @click="onSubmit">Confirmar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import BranchAutocompleteComponent from "@/views/pages/branch/BranchAutocomplete.vue"
import BranchSelectComponent from "@/views/pages/branch/BranchSelect.vue"
export default {
  components: { BranchAutocompleteComponent, BranchSelectComponent },
  data() {
    return {
      loading: false
    };
  },
  watch: {
    closeModalTransfer: function (val) {
      if(val){
        this.handleClose()
      }
    },
  },
  props: ['showDialogSelectBranch'],
  computed: {
    ...mapGetters(['isLogged', 'document', 'editDocument', 'closeModalTransfer']),
    defaultBranch() {
      return (this.document.branch) ? this.document.branch : this.isLogged.branch
    },
    defaultBranchDestination() {
      return (this.document.branchDestination) ? this.document.branchDestination : null
    }
  },
  methods: {
    ...mapMutations([
      'inputAndOutputAdjust/SET_BRANCH',
      'inputAndOutputAdjust/SET_CLOSE_MODAL_TRANSFER',
    ]),
    ...mapActions([
      'inputAndOutputAdjust/saveDocumentAction',
      'inputAndOutputAdjust/updateDocumentAction'
    ]),
    onSubmit() {
      if (!this.document.branch && !this.document.branchDestination) {
        this.$message.error('Debe seleccionar la bodega de origen y destino')
        return;
      }
      (this.editDocument)
        ? this['inputAndOutputAdjust/updateDocumentAction'](this.$route.meta.typeDocument)
        : this['inputAndOutputAdjust/saveDocumentAction']({
          type: this.$route.meta.type,
          typeDocument: this.$route.meta.typeDocument
        })
      //this.handleClose()
    },
    selectBranch(type, item) {
      type = (type == 1) ? 'branch' : 'branchDestinationId'
      this['inputAndOutputAdjust/SET_BRANCH']({ type, value: item })
    },
    clear(type) {
      type = (type == 1) ? 'branch' : 'branchDestination'
      this['inputAndOutputAdjust/SET_BRANCH']({ type, value: null })
    },
    handleClose() {
      this.$emit('close')
      this['inputAndOutputAdjust/SET_CLOSE_MODAL_TRANSFER'](false)
    },
    stopLoading(data) {
      this.loading = data
    }
  }
};
</script>